import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../components/PageHeader';
import { unwrap, useApi } from '../lib/api';

export function AuditPage() {
  const { client } = useApi();
  const rows = useQuery({
    queryKey: ['admin-audit'],
    queryFn: async () =>
      unwrap(await client.GET('/admin/audit', { params: { query: { take: 200 } } })),
  });

  return (
    <>
      <PageHeader
        title="Audit log"
        description="Content publishes, grants and revokes, imports, rejected raids, and account deletions."
      />
      <table className="w-full border-2 border-ink bg-white text-sm">
        <thead className="bg-ink text-newsprint">
          <tr>
            <th className="px-2 py-1 text-left">When</th>
            <th className="px-2 py-1 text-left">Action</th>
            <th className="px-2 py-1 text-left">Target</th>
            <th className="px-2 py-1 text-left">Reason</th>
            <th className="px-2 py-1 text-left">Data</th>
          </tr>
        </thead>
        <tbody>
          {rows.data?.map((a) => (
            <tr key={a.id} className="border-t border-newsprint align-top">
              <td className="px-2 py-1 font-mono whitespace-nowrap">
                {new Date(a.at).toLocaleString()}
              </td>
              <td className="px-2 py-1 font-semibold">{a.action}</td>
              <td className="px-2 py-1 font-mono">
                {a.targetType}:{a.targetId}
              </td>
              <td className="px-2 py-1">{a.reason}</td>
              <td className="px-2 py-1 font-mono text-xs break-all">{a.dataJson}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
